export const categories = [
  { slug: "movie", name: "电影", icon: "ri-film-line", description: "最新院线大片、经典电影一网打尽" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line", description: "热门国产剧、海外剧集持续更新" },
  { slug: "variety", name: "综艺", icon: "ri-live-line", description: "爆笑综艺、真人秀精彩不断" },
  { slug: "anime", name: "动漫", icon: "ri-rocket-line", description: "日漫国漫、热血冒险应有尽有" },
];

export const movies = [
  {
    id: "1",
    title: "流浪地球3",
    category: "movie",
    categoryName: "电影",
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20Earth%2C%20dramatic%20lighting%2C%20epic%20space%20scene%2C%20cinematic%20quality%2C%20dark%20blue%20and%20orange%20tones%2C%20professional%20movie%20poster%20style&width=800&height=1200&seq=movie-poster-01&orientation=portrait",
    rating: 9.2,
    year: 2026,
    description: `太阳急速老化，持续膨胀，即将吞没整个太阳系。人类在地球表面建造了上万座行星发动机，开启\u201c流浪地球计划\u201d，带着地球去远方寻找新家园。第三部讲述人类在漫长的星际旅途中遭遇的全新危机与希望。`,
    tags: ["科幻", "灾难", "冒险", "国产"],
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    duration: "148分钟",
    updateTime: "2026-08-01",
  },
  {
    id: "2",
    title: "长安三万里2",
    category: "movie",
    categoryName: "电影",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20Tang%20Dynasty%20style%2C%20ancient%20Chinese%20palace%20and%20poets%2C%20warm%20golden%20tones%2C%20artistic%20illustration%2C%20elegant%20traditional%20painting%20style&width=800&height=1200&seq=movie-poster-02&orientation=portrait",
    rating: 8.9,
    year: 2026,
    description: "延续第一部的史诗篇章，安史之乱后，长安城满目疮痍。高适与李白在乱世中各自抉择，一首首千古名诗在烽火中诞生。本片以更加宏大的视角展现盛唐文人的家国情怀。",
    tags: ["动画", "历史", "文化", "国产"],
    director: "追光动画",
    actors: ["配音：杨天翔", "配音：凌振赫"],
    duration: "168分钟",
    updateTime: "2026-07-20",
  },
  {
    id: "3",
    title: "孤胆行动",
    category: "movie",
    categoryName: "电影",
    image: "https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20soldier%20in%20tactical%20gear%2C%20explosion%20background%2C%20intense%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20professional%20cinematic%20poster%20style&width=800&height=1200&seq=movie-poster-03&orientation=portrait",
    rating: 8.7,
    year: 2026,
    description: "一名退役特种兵在海外执行最后一次秘密任务时，意外发现了一个惊天阴谋。他必须在72小时内孤身潜入敌营，阻止一场可能引发国际冲突的危机。全程高能动作戏，肾上腺素飙升。",
    tags: ["动作", "军事", "悬疑", "国产"],
    director: "林超贤",
    actors: ["张译", "段奕宏", "黄景瑜"],
    duration: "135分钟",
    updateTime: "2026-08-05",
  },
  {
    id: "4",
    title: "深海传说",
    category: "anime",
    categoryName: "动漫",
    image: "https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20with%20underwater%20world%2C%20colorful%20coral%20reef%2C%20mysterious%20deep%20ocean%2C%20magical%20creatures%2C%20vibrant%20blues%20and%20purples%2C%20dreamy%20atmosphere&width=800&height=1200&seq=movie-poster-04&orientation=portrait",
    rating: 9.0,
    year: 2026,
    description: "少女小渔在一次海难后被神秘力量带入深海世界，发现自己是传说中海之民的后裔。在海底王国，她结识了各种奇妙的海洋生物朋友，并踏上了寻找失落文明的奇幻冒险之旅。",
    tags: ["奇幻", "冒险", "治愈", "国产动画"],
    director: "田晓鹏",
    actors: ["配音：周冬雨", "配音：易烊千玺"],
    duration: "112分钟",
    updateTime: "2026-07-15",
  },
  {
    id: "5",
    title: "山河令之风云再起",
    category: "tv",
    categoryName: "电视剧",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20martial%20arts%20warriors%2C%20ancient%20Chinese%20landscape%2C%20flowing%20robes%2C%20dramatic%20composition%2C%20elegant%20traditional%20aesthetic&width=800&height=1200&seq=movie-poster-05&orientation=portrait",
    rating: 8.8,
    year: 2026,
    description: "江湖风云再起，昔日英雄重出江湖。一场关于武林至尊的争夺在各大门派间悄然展开，恩怨情仇交织，刀光剑影中谁是真正的武林第一？全剧40集，每一集都是视觉盛宴。",
    tags: ["古装", "武侠", "剧情", "国产剧"],
    director: "郑伟文",
    actors: ["肖战", "王一博", "赵丽颖"],
    duration: "40集",
    updateTime: "2026-08-03",
  },
  {
    id: "6",
    title: "都市夜话",
    category: "tv",
    categoryName: "电视剧",
    image: "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20with%20city%20skyline%20at%20night%2C%20young%20professionals%2C%20warm%20neon%20lights%2C%20romantic%20atmosphere%2C%20contemporary%20Chinese%20drama%20style&width=800&height=1200&seq=movie-poster-06&orientation=portrait",
    rating: 8.5,
    year: 2026,
    description: "四个在上海打拼的年轻人，在同一栋公寓里相遇。他们各自怀揣梦想，在繁华都市中经历爱情、友情、事业的起起落落。一部温暖治愈的都市情感剧，真实还原当代年轻人的生活状态。",
    tags: ["都市", "情感", "励志", "国产剧"],
    director: "张晓波",
    actors: ["杨紫", "李现", "关晓彤"],
    duration: "36集",
    updateTime: "2026-07-28",
  },
  {
    id: "7",
    title: "爆笑家族2",
    category: "variety",
    categoryName: "综艺",
    image: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20laughing%2C%20colorful%20playful%20design%2C%20game%20show%20elements%2C%20bright%20energetic%20style%2C%20fun%20vibrant%20atmosphere&width=800&height=1200&seq=movie-poster-07&orientation=portrait",
    rating: 8.6,
    year: 2026,
    description: "国内最火爆的家庭搞笑综艺回归！五组明星家庭在全新的挑战中爆笑连连。密室逃脱、厨艺比拼、户外生存，每一期都让你笑到停不下来。",
    tags: ["搞笑", "家庭", "真人秀", "国产综艺"],
    director: "严敏",
    actors: ["沈腾", "贾玲", "岳云鹏"],
    duration: "12期",
    updateTime: "2026-08-06",
  },
  {
    id: "8",
    title: "极限冒险王",
    category: "variety",
    categoryName: "综艺",
    image: "https://readdy.ai/api/search-image?query=Adventure%20reality%20show%20poster%20with%20mountain%20climbing%2C%20extreme%20sports%2C%20dramatic%20nature%20landscape%2C%20adventurous%20spirit%2C%20bold%20dynamic%20composition&width=800&height=1200&seq=movie-poster-08&orientation=portrait",
    rating: 8.4,
    year: 2026,
    description: "八位明星挑战全球最极限的冒险任务。从亚马逊丛林到撒哈拉沙漠，从珠峰大本营到马里亚纳海沟，他们用勇气和智慧完成一个个不可能的任务。",
    tags: ["冒险", "挑战", "明星", "国产综艺"],
    director: "陈伟",
    actors: ["黄渤", "彭于晏", "张钧甯"],
    duration: "10期",
    updateTime: "2026-07-25",
  },
  {
    id: "9",
    title: "星辰大海",
    category: "anime",
    categoryName: "动漫",
    image: "https://readdy.ai/api/search-image?query=Space%20adventure%20anime%20poster%20with%20spaceship%20and%20stars%2C%20futuristic%20mecha%20design%2C%20nebula%20background%2C%20young%20pilot%2C%20epic%20sci-fi%20atmosphere&width=800&height=1200&seq=movie-poster-09&orientation=portrait",
    rating: 9.1,
    year: 2026,
    description: "公元2150年，人类文明已经遍布银河系。少年林星在意外中获得一艘远古外星飞船的认可，从此踏上了在浩瀚星海中探索未知文明的征程。每集制作精良，画面堪称电影级别。",
    tags: ["科幻", "机甲", "冒险", "国产动画"],
    director: "艺画开天",
    actors: ["配音：边江", "配音：季冠霖"],
    duration: "24集",
    updateTime: "2026-08-04",
  },
  {
    id: "10",
    title: "逆光飞翔",
    category: "movie",
    categoryName: "电影",
    image: "https://readdy.ai/api/search-image?query=Inspirational%20movie%20poster%20with%20dancer%20silhouette%20against%20sunlight%2C%20dreamy%20warm%20golden%20lighting%2C%20emotional%20atmosphere%2C%20artistic%20cinematic%20style&width=800&height=1200&seq=movie-poster-10&orientation=portrait",
    rating: 8.8,
    year: 2026,
    description: "一个失去听力的女孩，凭着对舞蹈的执着与热爱，在无声的世界里舞出最美的旋律。改编自真实故事，一部让你感动落泪的励志佳作。",
    tags: ["励志", "舞蹈", "剧情", "国产"],
    director: "张一白",
    actors: ["刘浩存", "易烊千玺", "惠英红"],
    duration: "125分钟",
    updateTime: "2026-07-30",
  },
  {
    id: "11",
    title: "大秦帝国之天下",
    category: "tv",
    categoryName: "电视剧",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20drama%20poster%20with%20ancient%20army%20and%20emperor%2C%20Qin%20Dynasty%20aesthetic%2C%20grand%20scale%20battle%20scene%2C%20dark%20dramatic%20tones&width=800&height=1200&seq=movie-poster-11&orientation=portrait",
    rating: 9.3,
    year: 2026,
    description: "秦王嬴政在吕不韦、李斯等人的辅佐下，灭六国、统天下，建立了中国历史上第一个大一统王朝。本剧以宏大的历史视角，再现那段波澜壮阔的史诗岁月。",
    tags: ["历史", "战争", "权谋", "国产剧"],
    director: "张黎",
    actors: ["张鲁一", "段奕宏", "李乃文"],
    duration: "58集",
    updateTime: "2026-08-02",
  },
  {
    id: "12",
    title: "美食探秘",
    category: "variety",
    categoryName: "综艺",
    image: "https://readdy.ai/api/search-image?query=Food%20documentary%20show%20poster%20with%20delicious%20Chinese%20cuisine%2C%20colorful%20ingredients%2C%20steaming%20hot%20dishes%2C%20warm%20appetizing%20atmosphere%2C%20professional%20food%20photography&width=800&height=1200&seq=movie-poster-12&orientation=portrait",
    rating: 8.7,
    year: 2026,
    description: "顶级美食家带你走遍中国，探寻各地最地道的美味。从街头小吃到宫廷御膳，每一道菜背后都有一个动人的故事。准备好纸巾，因为你会馋到流口水！",
    tags: ["美食", "文化", "旅行", "纪录片"],
    director: "陈晓卿",
    actors: ["蔡澜", "陈晓卿", "李子柒"],
    duration: "8期",
    updateTime: "2026-08-01",
  },
];